import { render, staticRenderFns } from "./Referencia.vue?vue&type=template&id=6a4fcc5e&"
import script from "./Referencia.vue?vue&type=script&lang=js&"
export * from "./Referencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports